/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { checkDuplicate, createCategory, deleteCategory, listCategory, updateCategory } from "./_requests";

const Category = (data: any) => {
  const { userProfile } = useProfile();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [Category, setCategory] = useState<any>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [CategoryToDeleteId, setCategoryToDeleteId] = useState<string>("");
  const [CategoryToDeleteName, setCategoryToDeleteName] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");

  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
  }, [modal]);

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = () => {
    listCategory().then((res: any) => {
      setCategory(res.data);
    });
  };

  // Delete Data

  const onClickDelete = useCallback(
    (Category: any) => {
      if (Category.productCount > 0) {
        toast.warning(
          `Cannot delete "${Category.name}" because it has ${Category.productCount} associated products.`,
          { autoClose: 5000 }
        );
        return;
      }
      setCategoryToDeleteName(Category.name);
      setCategoryToDeleteId(Category.id);
      toggleDeleteModal();
    },
    [setCategoryToDeleteName, setCategoryToDeleteId, toggleDeleteModal]
  );
  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      name: "",
      category_id: "", // Optional field
      expected_delivery_in_days: "",
      delivery_reminder: false,
      reminder_time: "",
      content: "",
      list_order: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      list_order: Yup.number().typeError("Must be a number").required("Order is required"),
      category_id: Yup.string().nullable(), // Make this field optional
      expected_delivery_in_days: Yup.number()
        .typeError("Must be a number")
        .required("Expected Delivery days is required")
        .min(0, "Must be 0 or more")
        .integer("Must be an integer"),
      delivery_reminder: Yup.boolean(),
      reminder_time: Yup.string().nullable(),
      content: Yup.string().nullable(),
    }),
    onSubmit: async (values: any) => {
      const userId = userProfile?.userId;

      const data = {
        name: values.name,
        list_order: values.list_order,
        category_id: values.category_id || null, // Set to null if not provided
        expected_delivery_in_days: values.expected_delivery_in_days,
        delivery_reminder: values.delivery_reminder,
        reminder_time: values.delivery_reminder ? (values.reminder_time || null) : null,
        content: values.delivery_reminder ? (values.content || null) : null,
        ...(isEdit ? { updated_by: userId } : { created_by: userId }),
      };

      try {
        if (isEdit) {
          await updateCategory(data, values.id).then((res: any) => {
            toast.success(res.message, { autoClose: 3000 });
          });
        } else {
          await createCategory(data).then((res: any) => {
            toast.success(res.message, { autoClose: 3000 });
          });
        }
        fetchCategory();
        validation.resetForm();
      } catch (error) {
        toast.error("An error occurred, please try again.", {
          autoClose: 3000,
        });
      }

      toggle();
    },
  });

  const confirmDelete = async (CategoryId: any) => {
    try {
      const res: any = await deleteCategory(CategoryId, userProfile?.userId);
      toast.success(res?.message, { autoClose: 3000 });
      toggleDeleteModal();
      await fetchCategory();
    } catch (error) {
      toast.error('Failed to delete category');
    }
  };

  // Update Data
  const handleCategoryClick = useCallback(
    (Category: any) => {
      validation.setValues({
        id: Category.id,
        name: Category.name,
        list_order: Category.list_order || "",
        category_id: Category.category_id || "", // Set to empty string if undefined
        expected_delivery_in_days: Category.expected_delivery_in_days || "",
        delivery_reminder: Category.delivery_reminder || false,
        reminder_time: Category.reminder_time || "",
        content: Category.content || "",
      });
      setIsEdit(true);
      toggle();
    },
    [toggle, validation]
  );

  // Categorys Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Category Name",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Order",
        accessorKey: "list_order",
        enableColumnFilter: false,
      },
      {
        header: "Parent Category",
        accessorKey: "parentCategory.name",
        enableColumnFilter: false,
        cell: ({ getValue }: any) => getValue() ? getValue() : "-", // Custom cell rendering
      },
      {
        header: "Delivery (Days)",
        accessorKey: "expected_delivery_in_days",
        enableColumnFilter: false,
      },
      {
        header: "Delivery Reminder",
        accessorKey: "delivery_reminder",
        enableColumnFilter: false,
        cell: ({ getValue, row }: any) => (
          <div>
            <span className={`badge ${getValue() ? "bg-success" : "bg-secondary"}`}>
              {getValue() ? "Yes" : "No"}
            </span>
            {getValue() && row.original.reminder_time && (
              <span className="badge bg-warning text-dark ms-1" style={{ fontSize: "11px" }}>
                ⏰ {row.original.reminder_time}
              </span>
            )}
            <br />
            <small className="text-muted" style={{ fontSize: "11px" }}>
              {getValue()
                ? `(Reminder popup shown when place order after ${row.original.reminder_time} )`
                : "(No reminder when place order)"}
            </small>
            {getValue() && row.original.content && (
              <div className="text-muted mt-1" style={{ fontSize: "11px", fontStyle: "italic", whiteSpace: "pre-wrap" }}>
                "{row.original.content}"
              </div>
            )}
          </div>
        ),
      },
      {
        header: "Products Count",
        accessorKey: "productCount",
        enableColumnFilter: false,
        cell: ({ getValue }: any) => getValue() || 0,
      },
      {
        header: "Action",
        cell: (cellProps: any) => {
          const category = cellProps.row.original;
          const hasProducts = category.productCount > 0;

          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={() => handleCategoryClick(category)}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li
                className="list-inline-item"
                title={hasProducts ? `Cannot delete - ${category.productCount} product(s) exist` : "Remove"}
                data-bs-toggle="tooltip" // Enable Bootstrap tooltip
                data-bs-placement="top"
              >
                {hasProducts ? (
                  <span
                    className="text-danger d-inline-block"
                    style={{
                      cursor: "not-allowed",
                      opacity: 0.5,
                      position: 'relative'
                    }}
                  >
                    <i className="ri-delete-bin-5-fill fs-16"></i>
                    {/* Small badge showing product count */}
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{
                        fontSize: '0.5em',
                        padding: '0.25em 0.4em'
                      }}
                    >
                      {category.productCount}
                    </span>
                  </span>
                ) : (
                  <Link
                    to="#"
                    className="text-danger d-inline-block remove-item-btn"
                    onClick={() => onClickDelete(category)}
                  >
                    <i className="ri-delete-bin-5-fill fs-16"></i>
                  </Link>
                )}
              </li>
            </ul>
          );
        },
      }
    ],
    [handleCategoryClick, onClickDelete]
  );

  const addCategory = () => {
    setIsEdit(false);
    toggle();
    validation.setValues({ name: "", list_order: "", category_id: "", expected_delivery_in_days: "", delivery_reminder: false, reminder_time: "", content: "" });
  };

  document.title = "Paal Dappa | Admin panel";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Category" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card id="CategoryList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Category List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        <button
                          type="button"
                          className="btn text-white add-btn me-1"
                          style={{
                            backgroundColor: "#28a8df",
                            borderColor: "#28a8df",
                          }}
                          id="create-btn"
                          onClick={addCategory}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                          Category
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <div>
                    <TableContainer
                      columns={columns}
                      data={Category || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      SearchPlaceholder="Search Category..."
                    />
                  </div>

                  <Modal id="showModal" isOpen={modal} toggle={toggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Category" : "Add Category"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e: any) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div className="mb-3">
                          <Label
                            htmlFor="Categoryname-field"
                            className="form-label"
                          >
                            Category Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            id="Categoryname-field"
                            className="form-control"
                            placeholder="Enter Category Name"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="list-order-field" className="form-label">
                            List Order <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="list_order"
                            id="list-order-field"
                            className="form-control"
                            placeholder="Enter Order"
                            type="number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.list_order || ""}
                            invalid={validation.touched.list_order && validation.errors.list_order ? true : false}
                          />
                          {validation.touched.list_order && validation.errors.list_order ? (
                            <FormFeedback type="invalid">{validation.errors.list_order}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label
                            htmlFor="status-field"
                            className="form-label"
                          >
                            Parent Category (Optional)
                          </Label>

                          <Input
                            name="category_id"
                            type="select"
                            className="form-select"
                            id="status-field"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.category_id || ""}
                          >
                            <option value="">Select a parent category...</option>
                            {Category?.map((item: any, index: any) => (
                              <option value={item.id} key={index}>
                                {item.name}
                              </option>
                            ))}
                          </Input>
                        </div>

                        <div className="mb-3">
                          <Label
                            htmlFor="delivery-days-field"
                            className="form-label"
                          >
                            Expected Delivery (Days) <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="expected_delivery_in_days"
                            id="delivery-days-field"
                            className="form-control"
                            placeholder="Enter Delivery Days"
                            type="number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.expected_delivery_in_days || ""}
                            invalid={
                              validation.touched.expected_delivery_in_days && validation.errors.expected_delivery_in_days
                                ? true
                                : false
                            }
                          />
                          {validation.touched.expected_delivery_in_days && validation.errors.expected_delivery_in_days ? (
                            <FormFeedback type="invalid">
                              {validation.errors.expected_delivery_in_days}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Delivery Reminder</Label>
                          <div className="form-check form-switch">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="delivery-reminder-field"
                              name="delivery_reminder"
                              checked={validation.values.delivery_reminder || false}
                              onChange={(e) => {
                                validation.setFieldValue("delivery_reminder", e.target.checked);
                                if (!e.target.checked) validation.setFieldValue("reminder_time", "");
                              }}
                            />
                            <Label className="form-check-label" htmlFor="delivery-reminder-field">
                              {validation.values.delivery_reminder ? "Yes" : "No"}
                            </Label>
                          </div>
                        </div>

                        {validation.values.delivery_reminder && (
                          <>
                            <div className="mb-3">
                              <Label htmlFor="reminder-time-field" className="form-label">
                                Reminder Time <span className="text-muted">(24hr)</span>
                              </Label>
                              <Input
                                type="time"
                                name="reminder_time"
                                id="reminder-time-field"
                                className="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.reminder_time || ""}
                              />
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="content-field" className="form-label">
                                Reminder Content
                              </Label>
                              <Input
                                type="textarea"
                                name="content"
                                id="content-field"
                                className="form-control"
                                placeholder="Enter Reminder Content"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.content || ""}
                                rows={3}
                              />
                            </div>
                          </>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            Close
                          </button>

                          <button
                            type="submit"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            disabled={Duplicate}
                          >
                            {!!isEdit ? "Update" : "Add Category"}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
            <ModalHeader toggle={toggleDeleteModal}>
              Confirm Deletion
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete the Category{" "}
              <strong>{CategoryToDeleteName}</strong>?
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={toggleDeleteModal}
              >
                Cancel
              </Button>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={() => {
                  confirmDelete(CategoryToDeleteId);
                  setModal(false);
                }}
              >
                Delete
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Category;